


import { useEffect, useState } from "react";
import {
  Table,
  Button,
  Spin,
  Alert,
  Space,
  message,
  Modal,
} from "antd";
import {
  ReloadOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from "@ant-design/icons";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getBDPODistrictwiseGSCompliance, getGPwiseGSComplianceBDPO } from "../api/User";

const DistrictwiseSpecialGSComplianceBDPO = ({ dateFilter }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [gpCurrentPage, setGpCurrentPage] = useState(1);
  const [gpPageSize, setGpPageSize] = useState(10);

  /* ================= GP MODAL STATE ================= */
  const [gpModalOpen, setGpModalOpen] = useState(false);
  const [gpModalTitle, setGpModalTitle] = useState("");
  const [gpData, setGpData] = useState([]);
  const [gpLoading, setGpLoading] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);

  const numberSorter = (a, b, key) => {
    const valA = a[key] || 0;
    const valB = b[key] || 0;
    return valA - valB;
  };

  const stringSorter = (a, b, key) => {
    const valA = (a[key] || '').toString().toLowerCase();
    const valB = (b[key] || '').toString().toLowerCase();
    return valA.localeCompare(valB);
  };

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      width: 60,
      align: "center",
      fixed: "left",
      sorter: (a, b) => numberSorter(a, b, 'sr_no'),
    },
    {
      title: "District",
      dataIndex: "district_name",
      width: 150,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'district_name'),
    },
    {
      title: "Block",
      dataIndex: "block_name",
      width: 160,
      align: "center",
      sorter: (a, b) => stringSorter(a, b, 'block_name'),

    },
    {
      title: "No. of Panchayats",
      dataIndex: "gp_count",
      key: "gp_count",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'gp_count'),
      render: (val, record) => (
        <span
          onClick={() => openGPFromBlock(record)}
          style={{
            color: "#1677ff",
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 500,
          }}
        >
          {val || 0}
        </span>
      ),

    },
    {
      title: "1st Meeting",
      children: [
        { title: "No. of GPs conducted gram sabha", dataIndex: "m1_conducted", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_conducted') },
        { title: "No of GPs updated voters, mom, Attendance", dataIndex: "m1_updated", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_updated') },
        { title: "Quorum Fullfilled", dataIndex: "m1_quorum_yes", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes') },
        { title: "Quorum Failed", dataIndex: "m1_quorum_no", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no') },
      ],
    },
    {
      title: "2nd Meeting",
      children: [
        { title: "No. of GPs conducted gram sabha", dataIndex: "m2_conducted", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_conducted') },
        { title: "No of GPs updated voters, mom, Attendance", dataIndex: "m2_updated", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_updated') },
        { title: "Quorum Fullfilled", dataIndex: "m2_quorum_yes", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes') },
        { title: "Quorum Failed", dataIndex: "m2_quorum_no", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no') },
      ],
    },
    {
      title: "3rd Meeting",
      children: [
        { title: "No. of GPs conducted gram sabha", dataIndex: "m3_conducted", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_conducted') },
        { title: "No of GPs updated voters, mom, Attendance", dataIndex: "m3_updated", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_updated') },
        { title: "Quorum Fullfilled", dataIndex: "m3_quorum_yes", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes') },
        { title: "Quorum Failed", dataIndex: "m3_quorum_no", width: 100, align: "center", sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no') },
      ],
    },
    {
      title: "Never Rescheduled those Failed in 1st Meeting",
      dataIndex: "never_rescheduled",
      width: 140,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),
    },
  ];

  /* ================= GP MODAL COLUMNS ================= */
  const gpColumns = [
    {
      title: "Sr. No.",
      dataIndex: "sr_no",
      key: "sr_no",
      width: 60,
      align: "center",
      fixed: "left",
      sorter: (a, b) => numberSorter(a, b, 'sr_no'),
    },
    {
      title: "District Name",
      dataIndex: "district_name",
      width: 140,
      align: "center",
      fixed: "left",
      sorter: (a, b) => stringSorter(a, b, 'district_name'),
    },
    {
      title: "Block Name",
      dataIndex: "block_name",
      width: 160,
      align: "center",
      fixed: "left",
      sorter: (a, b) => stringSorter(a, b, 'block_name'),
    },
    {
      title: "Gram Panchayat Name",
      dataIndex: "gp_name",
      width: 200,
      align: "center",
      fixed: "left",
      sorter: (a, b) => stringSorter(a, b, 'gp_name'),
    },
    {
      title: "1st Meeting Conducted",
      dataIndex: "m1_conducted",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'm1_conducted'),
      render: (val) => <span>{val || 0}</span>,
    },
    {
      title: "1st Meeting Updated",
      dataIndex: "m1_updated",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'm1_updated'),
      render: (val) => <span>{val || 0}</span>,
    },
    {
      title: "1st Meeting Quorum",
      children: [
        {
          title: "Fulfilled",
          dataIndex: "m1_quorum_yes",
          width: 80,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm1_quorum_yes'),
          render: (val) => <span >{val || 0}</span>,
        },
        {
          title: "Failed",
          dataIndex: "m1_quorum_no",
          width: 80,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm1_quorum_no'),
          render: (val) => <span >{val || 0}</span>,
        },
      ],
    },
    {
      title: "2nd Meeting Conducted",
      dataIndex: "m2_conducted",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'm2_conducted'),
      render: (val) => <span>{val || 0}</span>,
    },
    {
      title: "2nd Meeting Updated",
      dataIndex: "m2_updated",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'm2_updated'),
      render: (val) => <span>{val || 0}</span>,
    },
    {
      title: "2nd Meeting Quorum",
      children: [
        {
          title: "Fulfilled",
          dataIndex: "m2_quorum_yes",
          width: 80,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm2_quorum_yes'),
          render: (val) => <span >{val || 0}</span>,
        },
        {
          title: "Failed",
          dataIndex: "m2_quorum_no",
          width: 80,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm2_quorum_no'),
          render: (val) => <span >{val || 0}</span>,
        },
      ],
    },
    {
      title: "3rd Meeting Conducted",
      dataIndex: "m3_conducted",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'm3_conducted'),
      render: (val) => <span>{val || 0}</span>,
    },
    {
      title: "3rd Meeting Updated",
      dataIndex: "m3_updated",
      width: 120,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'm3_updated'),
      render: (val) => <span>{val || 0}</span>,
    },
    {
      title: "3rd Meeting Quorum",
      children: [
        {
          title: "Fulfilled",
          dataIndex: "m3_quorum_yes",
          width: 80,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm3_quorum_yes'),
          render: (val) => <span >{val || 0}</span>,
        },
        {
          title: "Failed",
          dataIndex: "m3_quorum_no",
          width: 80,
          align: "center",
          sorter: (a, b) => numberSorter(a, b, 'm3_quorum_no'),
          render: (val) => <span >{val || 0}</span>,
        },
      ],
    },
    {
      title: "Never Rescheduled (After 1st Meeting Failure)",
      dataIndex: "never_rescheduled",
      width: 150,
      align: "center",
      sorter: (a, b) => numberSorter(a, b, 'never_rescheduled'),
      render: (val) => <span>{val || 0}</span>,
    },


  ];

  /* ================= FETCH DATA ================= */
  const fetchReportData = async () => {
    try {
      setLoading(true);
      setError(null);

      const token = sessionStorage.getItem("token");
      if (!token) {
        message.error("Authentication required");
        return;
      }

      const res = await getBDPODistrictwiseGSCompliance(token, dateFilter);

      if (res.success) {
        // DEBUG: Check what data we're getting
        console.log("API Response for blocks:", res.result);
        if (res.result.length > 0) {
          console.log("First block data:", res.result[0]);
          console.log("Available fields:", Object.keys(res.result[0]));
        }

        const formatted = res.result.map((item, index) => ({
          ...item,
          key: item.block_code || `block-${index}`,
          sr_no: index + 1,
          // Ensure we have these critical fields for the GP API call
          district_code: item.district_code || item.districtCode,
          block_code: item.block_code || item.blockCode,
          // Add gp_count
          gp_count: item.gp_count || item.no_of_gram_panchayats || item.total_gps || 0,
        }));

        console.log("Formatted data sample:", formatted[0]); // Debug log
        setData(formatted);
      } else {
        setError(res.message);
      }
    } catch (err) {
      setError(err.message || "Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReportData();
  }, [dateFilter]);

  /* ================= GP MODAL FUNCTIONS ================= */
  const openGPFromBlock = async (block) => {
    console.log('Opening GP modal for block:', block.block_name);
    console.log('Block data:', block); // Debug log to see what data we have
    setSelectedBlock(block);
    setGpModalTitle(`Gram Panchayat-wise Report : ${block.block_name} (${block.district_name})`);
    setGpModalOpen(true);
    setGpData([]);
    setGpLoading(true);

    try {
      const token = sessionStorage.getItem("token");

      if (!token) {
        message.error("No authentication token found");
        setGpLoading(false);
        return;
      }

      // Ensure we have district_code and block_code
      if (!block.district_code) {
        message.error("District code is missing for this block");
        setGpLoading(false);
        return;
      }

      if (!block.block_code) {
        message.error("Block code is missing for this block");
        setGpLoading(false);
        return;
      }

      console.log(`Calling API with district_code: ${block.district_code}, block_code: ${block.block_code}`);

      // Pass both district_code and block_code to the API
      const result = await getGPwiseGSComplianceBDPO(token, block.district_code, block.block_code);

      if (result.success) {
        const gpFormatted = result.result.map((item, index) => ({
          ...item,
          key: item.panchayat_code || `gp-${index}`,
          sr_no: index + 1,
          district_name: item.district_name || block.district_name,
          block_name: item.block_name || block.block_name,
          gp_name: item.panchayat_name || item.gp_name || "N/A",
          // Map your specific meeting data here
          m1_conducted: item.m1_conducted || 0,
          m1_updated: item.m1_updated || 0,
          m1_quorum_yes: item.m1_quorum_yes || 0,
          m1_quorum_no: item.m1_quorum_no || 0,
          m2_conducted: item.m2_conducted || 0,
          m2_updated: item.m2_updated || 0,
          m2_quorum_yes: item.m2_quorum_yes || 0,
          m2_quorum_no: item.m2_quorum_no || 0,
          m3_conducted: item.m3_conducted || 0,
          m3_updated: item.m3_updated || 0,
          m3_quorum_yes: item.m3_quorum_yes || 0,
          m3_quorum_no: item.m3_quorum_no || 0,
          never_rescheduled: item.never_rescheduled || 0,
        }));

        setGpData(gpFormatted);
        message.success(`Loaded ${gpFormatted.length} gram panchayats for ${block.block_name}`);
      } else {
        message.error(result.message || 'Failed to fetch GP data');
      }
    } catch (err) {
      console.error('Error fetching GP data:', err);
      message.error(err.message || 'Failed to fetch GP data. Please try again.');
    } finally {
      setGpLoading(false);
    }
  };

  const handleExportGpExcel = () => {
    if (!gpData.length) return message.warning("No data to export");

    try {
      const excelData = gpData.map((row, idx) => ({
        "Sr. No.": idx + 1,
        "District Name": row.district_name || "-",
        "Block Name": row.block_name || "-",
        "Gram Panchayat Name": row.gp_name || "-",

        "1st Meeting Conducted": row.m1_conducted || 0,
        "1st Meeting Updated": row.m1_updated || 0,
        "1st Meeting Quorum Fulfilled": row.m1_quorum_yes || 0,
        "1st Meeting Quorum Failed": row.m1_quorum_no || 0,

        "2nd Meeting Conducted": row.m2_conducted || 0,
        "2nd Meeting Updated": row.m2_updated || 0,
        "2nd Meeting Quorum Fulfilled": row.m2_quorum_yes || 0,
        "2nd Meeting Quorum Failed": row.m2_quorum_no || 0,

        "3rd Meeting Conducted": row.m3_conducted || 0,
        "3rd Meeting Updated": row.m3_updated || 0,
        "3rd Meeting Quorum Fulfilled": row.m3_quorum_yes || 0,
        "3rd Meeting Quorum Failed": row.m3_quorum_no || 0,

        "Never Rescheduled": row.never_rescheduled || 0,
      }));

      // 🔽 GRAND TOTAL ROW (ALL COLUMNS)
      excelData.push({
        "Sr. No.": "GRAND TOTAL",
        "District Name": "",
        "Block Name": "",
        "Gram Panchayat Name": "",

        "1st Meeting Conducted": gpGrandTotals.m1_conducted,
        "1st Meeting Updated": gpGrandTotals.m1_updated,
        "1st Meeting Quorum Fulfilled": gpGrandTotals.m1_quorum_yes,
        "1st Meeting Quorum Failed": gpGrandTotals.m1_quorum_no,

        "2nd Meeting Conducted": gpGrandTotals.m2_conducted,
        "2nd Meeting Updated": gpGrandTotals.m2_updated,
        "2nd Meeting Quorum Fulfilled": gpGrandTotals.m2_quorum_yes,
        "2nd Meeting Quorum Failed": gpGrandTotals.m2_quorum_no,

        "3rd Meeting Conducted": gpGrandTotals.m3_conducted,
        "3rd Meeting Updated": gpGrandTotals.m3_updated,
        "3rd Meeting Quorum Fulfilled": gpGrandTotals.m3_quorum_yes,
        "3rd Meeting Quorum Failed": gpGrandTotals.m3_quorum_no,

        "Never Rescheduled": gpGrandTotals.never_rescheduled,
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "GP Report");

      const fileName = `GP_Report_${selectedBlock?.block_name?.replace(/\s+/g, '_') || 'Block'}_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      message.success("GP Excel file exported successfully");
    } catch (err) {
      console.error("GP Excel Export Error:", err);
      message.error("Failed to export GP Excel");
    }
  };


  /* ================= EXPORT PDF ================= */
  const handleExportPDF = () => {
    if (!data.length) return;

    const doc = new jsPDF("landscape");
    doc.setFontSize(16);
    doc.text(
      "Blockwise Special Gram Sabha Meeting Compliance (BDPO)",
      148,
      15,
      { align: "center" }
    );

    // Update headers to include new column
    const headers = [
      "Sr. No.",
      "District",
      "Block",
      "No. of Panchayats",
      "1st Meeting - Conducted",
      "1st Meeting - Updated",
      "1st Meeting - Quorum Yes",
      "1st Meeting - Quorum No",
      "2nd Meeting - Conducted",
      "2nd Meeting - Updated",
      "2nd Meeting - Quorum Yes",
      "2nd Meeting - Quorum No",
      "3rd Meeting - Conducted",
      "3rd Meeting - Updated",
      "3rd Meeting - Quorum Yes",
      "3rd Meeting - Quorum No",
      "Never Rescheduled"
    ];

    const body = data.map(row => [
      row.sr_no,
      row.district_name,
      row.block_name,
      row.gp_count || 0,

      row.m1_conducted,
      row.m1_updated,
      row.m1_quorum_yes,
      row.m1_quorum_no,

      row.m2_conducted,
      row.m2_updated,
      row.m2_quorum_yes,
      row.m2_quorum_no,

      row.m3_conducted,
      row.m3_updated,
      row.m3_quorum_yes,
      row.m3_quorum_no,

      row.never_rescheduled,
    ]);

    // 🔽 ADD GRAND TOTAL ROW
    body.push([
      "GRAND TOTAL",
      "",
      "",
      grandTotals.gp_count,

      grandTotals.m1_conducted,
      grandTotals.m1_updated,
      grandTotals.m1_quorum_yes,
      grandTotals.m1_quorum_no,

      grandTotals.m2_conducted,
      grandTotals.m2_updated,
      grandTotals.m2_quorum_yes,
      grandTotals.m2_quorum_no,

      grandTotals.m3_conducted,
      grandTotals.m3_updated,
      grandTotals.m3_quorum_yes,
      grandTotals.m3_quorum_no,

      grandTotals.never_rescheduled,
    ]);
    autoTable(doc, {
      head: [headers],
      body,
      startY: 25,
      theme: "grid",
      headStyles: { fillColor: [22, 119, 255] },
      styles: { fontSize: 8 },

      didParseCell: function (data) {
        // last row = total row
        if (data.row.index === body.length - 1) {
          data.cell.styles.fillColor = [230, 247, 255]; // light blue
          data.cell.styles.fontStyle = "bold";
        }
      }
    });


    doc.save("BDPO_Special_GS_Compliance.pdf");
  };

  /* ================= EXPORT EXCEL ================= */
  const handleExportExcel = () => {
    const excelData = data.map(row => ({
      "Sr. No.": row.sr_no,
      "District": row.district_name,
      "Block": row.block_name,
      "No. of Panchayats": row.gp_count || 0,
      "1st Meeting Conducted": row.m1_conducted,
      "1st Meeting Updated": row.m1_updated,
      "1st Meeting Quorum Fulfilled": row.m1_quorum_yes,
      "1st Meeting Quorum Failed": row.m1_quorum_no,
      "2nd Meeting Conducted": row.m2_conducted,
      "2nd Meeting Updated": row.m2_updated,
      "2nd Meeting Quorum Fulfilled": row.m2_quorum_yes,
      "2nd Meeting Quorum Failed": row.m2_quorum_no,
      "3rd Meeting Conducted": row.m3_conducted,
      "3rd Meeting Updated": row.m3_updated,
      "3rd Meeting Quorum Fulfilled": row.m3_quorum_yes,
      "3rd Meeting Quorum Failed": row.m3_quorum_no,
      "Never Rescheduled": row.never_rescheduled,
    }));

    excelData.push({
      "Sr. No.": "GRAND TOTAL",
      "District": "",
      "Block": "",
      "No. of Panchayats": grandTotals.gp_count,
      "1st Meeting Conducted": grandTotals.m1_conducted,
      "1st Meeting Updated": grandTotals.m1_updated,
      "1st Meeting Quorum Fulfilled": grandTotals.m1_quorum_yes,
      "1st Meeting Quorum Failed": grandTotals.m1_quorum_no,
      "2nd Meeting Conducted": grandTotals.m2_conducted,
      "2nd Meeting Updated": grandTotals.m2_updated,
      "2nd Meeting Quorum Fulfilled": grandTotals.m2_quorum_yes,
      "2nd Meeting Quorum Failed": grandTotals.m2_quorum_no,
      "3rd Meeting Conducted": grandTotals.m3_conducted,
      "3rd Meeting Updated": grandTotals.m3_updated,
      "3rd Meeting Quorum Fulfilled": grandTotals.m3_quorum_yes,
      "3rd Meeting Quorum Failed": grandTotals.m3_quorum_no,
      "Never Rescheduled": grandTotals.never_rescheduled,
    });



    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Compliance");
    XLSX.writeFile(wb, "BDPO_Special_GS_Compliance.xlsx");
  };
  const grandTotals = {
    gp_count: data.reduce((s, i) => s + (i.gp_count || 0), 0),

    m1_conducted: data.reduce((s, i) => s + (i.m1_conducted || 0), 0),
    m1_updated: data.reduce((s, i) => s + (i.m1_updated || 0), 0),
    m1_quorum_yes: data.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
    m1_quorum_no: data.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),

    m2_conducted: data.reduce((s, i) => s + (i.m2_conducted || 0), 0),
    m2_updated: data.reduce((s, i) => s + (i.m2_updated || 0), 0),
    m2_quorum_yes: data.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
    m2_quorum_no: data.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),

    m3_conducted: data.reduce((s, i) => s + (i.m3_conducted || 0), 0),
    m3_updated: data.reduce((s, i) => s + (i.m3_updated || 0), 0),
    m3_quorum_yes: data.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
    m3_quorum_no: data.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),

    never_rescheduled: data.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
  };


  const gpGrandTotals = {
    m1_conducted: gpData.reduce((s, i) => s + (i.m1_conducted || 0), 0),
    m1_updated: gpData.reduce((s, i) => s + (i.m1_updated || 0), 0),
    m1_quorum_yes: gpData.reduce((s, i) => s + (i.m1_quorum_yes || 0), 0),
    m1_quorum_no: gpData.reduce((s, i) => s + (i.m1_quorum_no || 0), 0),

    m2_conducted: gpData.reduce((s, i) => s + (i.m2_conducted || 0), 0),
    m2_updated: gpData.reduce((s, i) => s + (i.m2_updated || 0), 0),
    m2_quorum_yes: gpData.reduce((s, i) => s + (i.m2_quorum_yes || 0), 0),
    m2_quorum_no: gpData.reduce((s, i) => s + (i.m2_quorum_no || 0), 0),

    m3_conducted: gpData.reduce((s, i) => s + (i.m3_conducted || 0), 0),
    m3_updated: gpData.reduce((s, i) => s + (i.m3_updated || 0), 0),
    m3_quorum_yes: gpData.reduce((s, i) => s + (i.m3_quorum_yes || 0), 0),
    m3_quorum_no: gpData.reduce((s, i) => s + (i.m3_quorum_no || 0), 0),

    never_rescheduled: gpData.reduce((s, i) => s + (i.never_rescheduled || 0), 0),
  };


  return (
    <div style={{ padding: 24, background: "#f0f2f5", minHeight: "100vh" }}>
      <div
        style={{
          background: "#fff",
          padding: 24,
          borderRadius: 8,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 20,
          }}
        >
          <div>
            <h2 style={{ fontSize: 20, fontWeight: 600, color: "#1f1f1f" }}>
              Blockwise Special Gram Sabha Meeting Compliance (BDPO)
            </h2>
            <p style={{ margin: 0, color: "#666" }}>
              Total Records: <strong>{data.length}</strong>
            </p>
          </div>

          <Space>
            <Button icon={<FilePdfOutlined />} onClick={handleExportPDF}>
              Export PDF
            </Button>
            <Button
              type="primary"
              icon={<FileExcelOutlined />}
              onClick={handleExportExcel}
            >
              Export Excel
            </Button>
            <Button icon={<ReloadOutlined />} onClick={fetchReportData}>
              Refresh
            </Button>
          </Space>
        </div>

        {error && <Alert type="error" message={error} showIcon />}

        {loading ? (
          <div style={{ textAlign: "center", padding: 60 }}>
            <Spin size="large" />
          </div>
        ) : (
          <Table
            columns={columns}
            dataSource={data}
            bordered
            size="small"
            scroll={{ x: 1900, y: 420 }}
            pagination={{
              current: currentPage,
              pageSize,
              total: data.length,
              showSizeChanger: true,
              // showQuickJumper: true,
            }}
            onChange={(p) => {
              setCurrentPage(p.current);
              setPageSize(p.pageSize);
            }}
          />

        )}
        {data.length > 0 && (
          <div style={{
            marginTop: 12,
            padding: "10px 14px",
            background: "#e6f7ff",
            border: "1px solid #91d5ff",
            borderRadius: 6,
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            fontSize: 12,
          }}>
            <strong>Grand Totals (All Pages):</strong>

            <span>GPs: <b>{grandTotals.gp_count}</b></span>

            <span>1st Conducted: <b>{grandTotals.m1_conducted}</b></span>
            <span>1st Updated: <b>{grandTotals.m1_updated}</b></span>
            <span>1st Quorum Yes: <b>{grandTotals.m1_quorum_yes}</b></span>
            <span>1st Quorum No: <b>{grandTotals.m1_quorum_no}</b></span>

            <span>2nd Conducted: <b>{grandTotals.m2_conducted}</b></span>
            <span>2nd Updated: <b>{grandTotals.m2_updated}</b></span>
            <span>2nd Quorum Yes: <b>{grandTotals.m2_quorum_yes}</b></span>
            <span>2nd Quorum No: <b>{grandTotals.m2_quorum_no}</b></span>

            <span>3rd Conducted: <b>{grandTotals.m3_conducted}</b></span>
            <span>3rd Updated: <b>{grandTotals.m3_updated}</b></span>
            <span>3rd Quorum Yes: <b>{grandTotals.m3_quorum_yes}</b></span>
            <span>3rd Quorum No: <b>{grandTotals.m3_quorum_no}</b></span>

            <span>Never Rescheduled: <b>{grandTotals.never_rescheduled}</b></span>
          </div>
        )}


      </div>

      {/* GP DETAILS MODAL */}
      <Modal
        open={gpModalOpen}
        onCancel={() => setGpModalOpen(false)}
        width={1300}
        destroyOnClose
        footer={null}
        closable
        style={{ top: 20 }}
        bodyStyle={{
          padding: '16px 0 0 0',
          overflow: 'hidden'
        }}
        title={
          <div style={{ paddingRight: 40 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: "16px", fontWeight: "600", color: "#1f1f1f" }}>
                {gpModalTitle}
              </span>

              <Button
                type="primary"
                icon={<FileExcelOutlined />}
                onClick={handleExportGpExcel}
                disabled={gpLoading || gpData.length === 0}
                style={{ fontWeight: 500 }}
              >
                Export Excel
              </Button>
            </div>
          </div>
        }
      >
        {gpLoading ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <Spin size="large" />
            <p style={{ marginTop: 10, color: "#666", fontWeight: 500 }}>
              Loading Gram Panchayat data...
            </p>
          </div>
        ) : gpData.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px", color: "#999" }}>
            <Alert
              message={<span style={{ fontWeight: 600 }}>No Data Available</span>}
              description={
                <span style={{ fontWeight: 500 }}>
                  No Gram Panchayat data found for {selectedBlock?.block_name}.
                  This block may not have any Gram Panchayats assigned or data is not available.
                </span>
              }
              type="info"
              showIcon
            />
          </div>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(80vh - 110px)',
            overflow: 'hidden'
          }}>
            <div style={{
              flex: 1,
              overflowY: 'auto',
              overflowX: 'auto',
              paddingRight: '4px'
            }}>
              <Table
                columns={gpColumns}
                dataSource={gpData}
                rowKey="key"
                bordered
                size="small"
                scroll={{
                  x: 1200,
                }}
                pagination={{
                  current: gpCurrentPage,
                  pageSize: gpPageSize,
                  total: gpData.length,
                  showSizeChanger: true,
                
                  pageSizeOptions: ["10", "20", "50", "100"],
                  showTotal: (total, range) =>
                    `${range[0]}-${range[1]} of ${total} records`,
                }}
                onChange={(pagination) => {
                  setGpCurrentPage(pagination.current);
                  setGpPageSize(pagination.pageSize);
                }}
              />
              {/* GRAND TOTAL STRIP */}
              <div
                style={{
                  marginTop: 10,
                  padding: "10px 14px",
                  background: "#f0f9ff",
                  borderRadius: 6,
                  border: "1px solid #bae0ff",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 12,
                  fontSize: 12,
                  flexShrink: 0
                }}
              >
                <strong>Grand Totals:</strong>

                <span>1st Conducted: <b>{gpGrandTotals.m1_conducted}</b></span>
                <span>1st Updated: <b>{gpGrandTotals.m1_updated}</b></span>
                <span>1st Quorum Yes: <b>{gpGrandTotals.m1_quorum_yes}</b></span>
                <span>1st Quorum No: <b>{gpGrandTotals.m1_quorum_no}</b></span>

                <span>2nd Conducted: <b>{gpGrandTotals.m2_conducted}</b></span>
                <span>2nd Updated: <b>{gpGrandTotals.m2_updated}</b></span>
                <span>2nd Quorum Yes: <b>{gpGrandTotals.m2_quorum_yes}</b></span>
                <span>2nd Quorum No: <b>{gpGrandTotals.m2_quorum_no}</b></span>

                <span>3rd Conducted: <b>{gpGrandTotals.m3_conducted}</b></span>
                <span>3rd Updated: <b>{gpGrandTotals.m3_updated}</b></span>
                <span>3rd Quorum Yes: <b>{gpGrandTotals.m3_quorum_yes}</b></span>
                <span>3rd Quorum No: <b>{gpGrandTotals.m3_quorum_no}</b></span>

                <span>Never Rescheduled: <b>{gpGrandTotals.never_rescheduled}</b></span>
              </div>


            </div>

            {/* SUMMARY STRIP */}

          </div>
        )}
      </Modal>
    </div>
  );
};

export default DistrictwiseSpecialGSComplianceBDPO;